import { Libraries } from '@react-google-maps/api';

const searchParams = new URLSearchParams(document.location.search);

export const env = searchParams.get('env');

export const BASE_URL = process.env.REACT_APP_API_BASE_URL;
// export const BASE_URL = "https://f4b0ee3d4113.ngrok-free.app/api/v1";
// export const BASE_URL = "http://localhost:5001/api/v1";

export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API;
export const GOOGLE_MAPS_LIBRARIES = ['places'] as Libraries;

export const WEBSOCKET_URL = BASE_URL?.split('/api/v1')[0];
// export const BASE_URL = "http://localhost:5001/api/v1";
export const DATE_FORMAT = 'DD MMM, YYYY hh:mm a';
